export default callback => {
    if(window.google) {
        callback(window.google.maps)
        return
    } else {
        if(!window.googleMapsCallbacks)
            window.googleMapsCallbacks = []
    
        window.googleMapsCallbacks.push(callback)
    }

    window.initMap = () => {
        window.googleMapsCallbacks.forEach(callback => {
            callback(window.google.maps)
        })
        window.googleLoading = false
    }

    if(!window.googleScriptLoaded) {
        const script = document.createElement("script")
        script.src = `https://maps.googleapis.com/maps/api/js?key=${window.gmak}&libraries=places&callback=initMap`
        script.async = true
        document.body.appendChild(script)
        window.googleScriptLoaded = true
    }
}

export const ComponentForm = place => {
    if(!place.address_components) return false

    let componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        country: 'long_name',
        postal_code: 'short_name'
    }

    let component = {}

place.address_components.forEach(componentItem => {
    componentItem.types.forEach(type => {
        if (componentForm[type] && !component[type]) {
            component[type] = componentItem[componentForm[type]];
        }
    });
});


    component['lat'] = place.geometry.location.lat()
    component['lng'] = place.geometry.location.lng()

    return component
}


// WEBPACK FOOTER //
// ./src/SPRINTA/third-party/GoogleMapsForm/index.js